document.querySelectorAll('.partners-section').forEach(function (section) {
  if (section.dataset.carouselInit) return;
  section.dataset.carouselInit = 'true';

  const track = section.querySelector('.carousel-track');
  const prevBtn = section.querySelector('.prev-arrow');
  const nextBtn = section.querySelector('.next-arrow');
  if (!track || track.children.length === 0) return;

  const originalItems = Array.from(track.children);
  const REPEATS = 6;
  for (let r = 0; r < REPEATS - 1; r++) {
    originalItems.forEach(function (item) {
      track.appendChild(item.cloneNode(true));
    });
  }

  const speedAttr = parseFloat(section.style.getPropertyValue('--speed'));
  let speed = isNaN(speedAttr) ? 0.6 : speedAttr;

  let singleSetWidth = 0;
  function measure() {
    singleSetWidth = originalItems.reduce(function (sum, el) {
      return sum + el.getBoundingClientRect().width;
    }, 0);
  }

  let offset = 0;
  let autoplay = true;
  let isDragging = false;
  let dragStartX = 0;
  let dragStartOffset = 0;
  let resumeTimer = null;
  let animId = null;

  function applyTransform() {
    track.style.transform = 'translateX(' + (-offset) + 'px)';
  }

  function normalizeOffset() {
    if (singleSetWidth <= 0) return;
    while (offset < 0) offset += singleSetWidth;
    while (offset >= singleSetWidth * (REPEATS - 2)) offset -= singleSetWidth;
  }

  function tick() {
    if (autoplay && !isDragging) {
      offset += speed;
      normalizeOffset();
      applyTransform();
    }
    requestAnimationFrame(tick);
  }

  function pauseThenResume(ms) {
    autoplay = false;
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () { autoplay = true; }, ms);
  }

  function animateTo(target) {
    if (animId) cancelAnimationFrame(animId);
    const start = offset;
    const distance = target - start;
    const duration = 350;
    const startTime = performance.now();
    function step(now) {
      const t = Math.min(1, (now - startTime) / duration);
      const ease = 1 - Math.pow(1 - t, 3);
      offset = start + distance * ease;
      normalizeOffset();
      applyTransform();
      if (t < 1) animId = requestAnimationFrame(step);
    }
    animId = requestAnimationFrame(step);
  }

  function goToStep(direction) {
    const step = singleSetWidth / originalItems.length;
    animateTo(offset + direction * step * 2);
    pauseThenResume(3500);
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goToStep(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToStep(1); });

  function onDragStart(clientX) {
    isDragging = true;
    autoplay = false;
    dragStartX = clientX;
    dragStartOffset = offset;
    track.classList.add('dragging');
    if (resumeTimer) clearTimeout(resumeTimer);
  }

  function onDragMove(clientX) {
    if (!isDragging) return;
    const delta = clientX - dragStartX;
    offset = dragStartOffset - delta;
    normalizeOffset();
    applyTransform();
  }

  function onDragEnd() {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('dragging');
    pauseThenResume(2500);
  }

  track.addEventListener('mousedown', function (e) { onDragStart(e.clientX); });
  window.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
  window.addEventListener('mouseup', onDragEnd);

  track.addEventListener('touchstart', function (e) { onDragStart(e.touches[0].clientX); }, { passive: true });
  track.addEventListener('touchmove', function (e) { onDragMove(e.touches[0].clientX); }, { passive: true });
  track.addEventListener('touchend', onDragEnd);

  window.addEventListener('resize', measure);
  setTimeout(measure, 50);
  requestAnimationFrame(tick);
});